export const DRIVER_SELECT_PREFIX = "driver:";
export const CARD_ASSIGNMENT_SELECT_PREFIX = "assignment:";
